import type { ButlerJsBridge, PermissionGroup } from '@butler/shared';

/**
 * Kotlin shell이 없는 브라우저(개발용)에서는 localStorage로 fallback.
 * 운영 모바일은 항상 window.Butler가 inject되어 그쪽이 우선.
 */
const LOCAL_TOKEN = 'butler.dev.token';
const LOCAL_USER = 'butler.dev.user_id';
const LOCAL_PHONE = 'butler.dev.phone';

class DevBridge implements ButlerJsBridge {
  getAuthToken(): string | null {
    return localStorage.getItem(LOCAL_TOKEN);
  }
  setAuthToken(token: string, userId: string, phoneE164: string): void {
    localStorage.setItem(LOCAL_TOKEN, token);
    localStorage.setItem(LOCAL_USER, userId);
    localStorage.setItem(LOCAL_PHONE, phoneE164);
  }
  clearAuthToken(): void {
    localStorage.removeItem(LOCAL_TOKEN);
    localStorage.removeItem(LOCAL_USER);
    localStorage.removeItem(LOCAL_PHONE);
  }
  playAudio(): void {
    /* dev no-op */
  }
  pauseAudio(): void {
    /* dev no-op */
  }
  requestPermission(_name: PermissionGroup): boolean {
    // dev: 시스템 다이얼로그 못 띄움. 항상 granted 시뮬레이션.
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent('butler:permission-changed', {
          detail: { name: _name, granted: true, results: {} },
        }),
      );
    }, 100);
    return false; // "이미 granted" 시그널
  }
  openSystemSettings(): void {
    /* dev no-op */
  }
  getAppVersion() {
    return { versionCode: 1, versionName: '0.1.0-dev' };
  }
  openCalendarOAuth(): void {
    /* dev no-op */
  }
  syncSms(_sinceEpochMs: number): void {
    /* dev no-op */
  }
  syncContacts(): void {
    /* dev no-op */
  }
  setRecordingEnabled(_enabled: boolean): void {
    /* dev no-op */
  }
  getBlockedContacts(): string {
    return localStorage.getItem('butler.dev.blocked_contacts') ?? '[]';
  }
  setBlockedContacts(jsonArray: string): void {
    localStorage.setItem('butler.dev.blocked_contacts', jsonArray);
  }
  pickContact(): void {
    // dev: 임의의 mock 연락처 1건 반환
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent('butler:contact-picked', {
          detail: {
            displayName: '테스트 연락처',
            numbersE164: ['+821012345678'],
          },
        }),
      );
    }, 100);
  }
  isNumberBlocked(_rawNumber: string): boolean {
    return false;
  }
  getBlockedSkipStats(): string {
    return JSON.stringify({ count: 0, lastAtMs: 0 });
  }
}

export function bridge(): ButlerJsBridge {
  if (typeof window === 'undefined') {
    throw new Error('bridge() called in non-browser env');
  }
  if (!window.Butler) {
    window.Butler = new DevBridge();
  }
  return window.Butler;
}
